import _ from 'underscore';
import { Model } from 'backbone';


export const PaymentItem = Model.extend({
  defaults: {
    is_active: true,
    is_donation: false,
  },

  url() {
    return `${new Model().url.apply(this)}/`;
  }
});


export const MapPaymentItem = Model.extend({
  defaults: () => ({ payment_items: [] }),
  isNew: () => true,

  initialize(options = {}) {
    this.options = options;
  },

  url() {
    return this.options.url;
  },

  toJSON() {
    return _(this.get('payment_items')).filter(item =>
      !!item.get('costcentre')).map(item => ({
        primary_payment_item: item.get('payment_item'),
        costcentre: item.get('costcentre'),
        is_donation: item.get('is_donation')
      })
    );
  },

  removePaymentItem(costcentre) {
    let toRemove = this.getPaymentItem(costcentre);
    if (!toRemove) {
      toRemove = this.getNew(costcentre);
    }

    toRemove.set({ payment_item: null });
    this.pushPaymentItem(toRemove);
  },

  addPaymentItem(costcentre, paymentItem) {
    let toUpdate = this.getPaymentItem(costcentre);
    if (!toUpdate) {
      toUpdate = this.getNew(costcentre);
    }
    toUpdate.set({
      costcentre: costcentre.id,
      payment_item: paymentItem,
      is_donation: costcentre.attributes.is_donation
    });

    this.pushPaymentItem(toUpdate);
  },

  getPaymentItem(costcentre) {
    const modelItems = this.get('payment_items');

    return _.reduce(modelItems, (memo, item) => {
      if (memo) {
        return memo;
      }
      if (item.get('costcentre') === costcentre.id) {
        item.is_donation = costcentre.attributes.is_donation;
        return item;
      }
    }, null);
  },

  pushPaymentItem(updatedItem) {
    const modelItems = this.get('payment_items');

    const exists = _.findWhere(modelItems, {
      costcentre: updatedItem.get('costcentre'),
      
    });
    if (!exists) {
      modelItems.push(updatedItem);
    }
  },

  getNew(costcentre) {
    console.log(costcentre);
    return new Model({
      costcentre: costcentre.id,
      payment_item: null,
      is_donation: costcentre.attributes.is_donation
    });
  }
});



// WEBPACK FOOTER //
// ./epayment/models/payment_item.js